import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';

import routeDetails from 'app/constants/routeDetails';

import sendTracker from 'app/utils/sendTracker';

import Header from 'app/components/Header';
import Footer from 'app/components/Footer';

import Contact from './Contact';
import Formula from './Formula';
import FullAnalysis from './FullAnalysis';
import Home from './Home';
import Questions from './Questions';
import Results from './Results';

import styles from './styles.css';

const Routes = ({ location }) => {
  const { pathname } = location;
  const willHideFooter = pathname === routeDetails.QUESTIONS.url;

  sendTracker(pathname);
  return (
    <div className={styles.pageWrap}>
      <Header />

      <Switch location={location}>
        <Route
          path={routeDetails.CONTACT.url}
          exact={true}
          component={Contact}
        />
        <Route
          path={routeDetails.FORMULA.url}
          exact={true}
          component={Formula}
        />
        <Route
          path={routeDetails.FULL_ANALYSIS.url}
          exact={true}
          component={FullAnalysis}
        />
        <Route path={routeDetails.HOME.url} exact={true} component={Home} />
        <Route
          path={routeDetails.QUESTIONS.url}
          exact={true}
          component={Questions}
        />
        <Route
          path={routeDetails.RESULTS.url}
          exact={true}
          component={Results}
        />
      </Switch>
      {!willHideFooter && <Footer />}
    </div>
  );
};

export default withRouter(Routes);



// WEBPACK FOOTER //
// ./src/routes/index.js